import React from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import './WorkCardStyles.css';

const WorkCard = ({ index, ...props }) => {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.15 });
  const isReversed = index % 2 === 1;
  const projectNumber = String(index + 1).padStart(2, '0');

  return (
    <article
      ref={ref}
      className={`project-row ${isReversed ? 'project-row--reverse' : ''} ${isVisible ? 'visible' : 'hidden'}`}
    >
      <span className="project-watermark" aria-hidden="true">{projectNumber}</span>

      <div className="project-media">
        <div className="project-frame">
          <img src={props.imgsrc} alt={props.title} loading="lazy" />
          <span className="frame-corner frame-corner--tl" />
          <span className="frame-corner frame-corner--tr" />
          <span className="frame-corner frame-corner--bl" />
          <span className="frame-corner frame-corner--br" />
        </div>
      </div>

      <div className="project-copy">
        <div className="project-copy-header">
          <span className="project-index">{projectNumber}</span>
          <span className="project-category">{props.category}</span>
        </div>

        <h2 className="project-name">{props.title}</h2>
        <p className="project-summary">{props.text}</p>

        <ul className="project-tags">
          {props.tags.map((tag) => (
            <li key={tag}>{tag}</li>
          ))}
        </ul>

        <div className="project-actions">
          <a
            href={props.source}
            target="_blank"
            rel="noopener noreferrer"
            className="project-link project-link--primary"
          >
            Source Code
            <FiArrowUpRight />
          </a>
        </div>
      </div>
    </article>
  );
};

export default WorkCard;
